export enum ProgramProgressionStatus {
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
  STOPPED = "STOPPED",
  COMPLETED = "COMPLETED",
}
